import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { ACCOUNT_SUSPENDED_EVENT, AccountSuspendedDetail } from '../utils/suspensionGuard';

/** Explains why the app just signed the user out, instead of leaving them with a screen of generic errors. */
const SuspensionNotice: React.FC = () => {
  const [detail, setDetail] = useState<AccountSuspendedDetail | null>(null);

  useEffect(() => {
    const handler = (e: Event) => setDetail((e as CustomEvent<AccountSuspendedDetail>).detail);
    window.addEventListener(ACCOUNT_SUSPENDED_EVENT, handler);
    return () => window.removeEventListener(ACCOUNT_SUSPENDED_EVENT, handler);
  }, []);

  if (!detail) return null;
  return (
    <Dialog open>
      <DialogTitle>Account suspended</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {detail.message}
          {detail.reason ? ` Reason: ${detail.reason}` : ''}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={() => window.location.assign('/')}>OK</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuspensionNotice;
